// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hint[data-v-757789b0]{font-size:.75rem;line-height:1.2}.max-width[data-v-757789b0]{max-width:27%}", ""]);
// Exports
module.exports = exports;
